module.exports = __webpack_public_path__ + "static/media/subscribeGuide2.a069d0f9.png";